// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
// import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

Vue.use(VueAwesomeSwiper);
// import VueVideoPlayer from 'vue-video-player';
// import 'video.js/dist/video-js.css'; // 基础样式
// Vue.use(VueVideoPlayer);
import App from './App'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
import router from './router/index'
import store from './store/index'
//导入网络请求

import axios from './axios/index'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
import YDUI from 'vue-ydui';
import 'vue-ydui/dist/ydui.rem.css';
Vue.use(YDUI);
import $ from 'jquery'

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
import Croppa from 'vue-croppa'
Vue.use(Croppa)

Vue.prototype.getQueryString=function(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  };
  return null;
}
Vue.prototype.getCookie=function(cname)
{
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++)
    {
        var c = ca[i].trim();
        if (c.indexOf(name)==0) return c.substring(name.length,c.length);
    }
    return "";
}
Vue.prototype.setCookie=function(cname,cvalue,exdays)
{
    var d = new Date();
    d.setTime(d.getTime()+(exdays*24*60*60*1000));
    var expires = "expires="+d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
},
Vue.prototype.getQueryString=function(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return decodeURIComponent(r[2]);
    };
    return null;
}
Vue.prototype.jump=function(path,arg){
  var obj={};
  obj={path:path,query:arg}
  this.$router.push(obj)
}
Vue.config.productionTip = false
//发布后是否显示提示
Vue.config.productionTip = false

//是否开启工具调试
Vue.config.devtools = process.env.NODE_ENV === 'development'

/* eslint-disable no-new */
new Vue({
  el: '#app',

  router,
  store,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js